import React, { useEffect, useMemo, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import { useTranslation } from "react-i18next";
import { FaExpand } from "react-icons/fa";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "./GalleryGrid.css";
import ScrollReveal, { revealItemProps } from "../common/Reveal";
import { isRtlLanguage } from "../../utils/i18n";

function GalleryGrid({ images, descriptionKey }) {
  const { t, i18n } = useTranslation();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const description = t(descriptionKey);
  const isAr = isRtlLanguage(i18n.language);

  const slides = useMemo(
    () =>
      images.map((src, index) => ({
        src,
        alt: `${description} ${index + 1}`,
      })),
    [images, description],
  );

  useEffect(() => {
    setLightboxOpen(false);
    setActiveIndex(0);
  }, [images]);

  const openLightbox = (index) => {
    setActiveIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <ScrollReveal stagger className="gallery-grid">
        {images.map((src, index) => (
          <button
            key={`${descriptionKey}-${index}`}
            type="button"
            {...revealItemProps(index, "gallery-card group")}
            onClick={() => openLightbox(index)}
            aria-label={`${description} ${index + 1}`}
          >
            <img
              src={src}
              alt={`${description} ${index + 1}`}
              loading="lazy"
              decoding="async"
              className="gallery-card__image"
            />
            <div className="gallery-card__overlay">
              <FaExpand className="gallery-card__icon" aria-hidden="true" />
              <p className="gallery-card__title text-start">{description}</p>
              <p className="gallery-card__hint text-start">{t("Click here")}</p>
            </div>
          </button>
        ))}
      </ScrollReveal>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={activeIndex}
        slides={slides}
        plugins={[Counter]}
        counter={{ container: { style: { top: "unset", bottom: 0 } } }}
        rtl={isAr}
        carousel={{ finite: false }}
        controller={{ closeOnBackdropClick: true }}
        on={{ view: ({ index }) => setActiveIndex(index) }}
      />
    </>
  );
}

GalleryGrid.revealManaged = true;

export default GalleryGrid;
